import { render, staticRenderFns } from "./HrDashboardTable.vue?vue&type=template&id=bf53eee2&scoped=true"
import script from "./HrDashboardTable.vue?vue&type=script&lang=js"
export * from "./HrDashboardTable.vue?vue&type=script&lang=js"
import style0 from "./HrDashboardTable.vue?vue&type=style&index=0&id=bf53eee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf53eee2",
  null
  
)

export default component.exports